/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc
 */

/**
 *  Completion rule for the steps sharing {@code order} on {@code ApprovalsRpc#createApproval}: ALL
 *  of them must approve, or ANY one of them. Orders without an entry use the approval's {@code
 *  approvalRules}. Deliberately separate from the internal and update stage requests so each
 *  endpoint's contract can evolve independently.
 */

/**
 *  Completion rule for the steps sharing {@code order} on {@code ApprovalsRpc#updateApproval}: ALL
 *  of them must approve, or ANY one of them. Deliberately separate from the create and internal
 *  stage requests so each endpoint's contract can evolve independently.
 */

export const createApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'createApproval',
  auth: 'app',
  fingerprint: '7MmYLwGCakwlRo5jvIUhl4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createBulkApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'createBulkApproval',
  auth: 'app',
  fingerprint: 'JSDgEpzYIhGTzVBYPr-nEYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLatestApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'getLatestApproval',
  auth: 'app',
  fingerprint: 'oVgYyyFd-qwHWl6cK_geNIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'getApproval',
  auth: 'app',
  fingerprint: 'tO7k9L9wKAGGBInSA-jrDYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'approveApproval',
  auth: 'app',
  fingerprint: 'w3LXpRbTttMA1s4Mxo8OH4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveApprovalStepRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'approveApprovalStep',
  auth: 'app',
  fingerprint: '-GF6GyjPgYJwZE77Y6-r0YT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'rejectApproval',
  auth: 'app',
  fingerprint: 'TCiJepipaVPY3hi03nO7xIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectApprovalStepRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'rejectApprovalStep',
  auth: 'app',
  fingerprint: '5BOwN5YSTXQWHub1jzeuyYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestChangesOnApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestChangesOnApproval',
  auth: 'app',
  fingerprint: 'oyjmK_MVwfqMR9AGrIAh-oT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestChangesOnApprovalStepRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestChangesOnApprovalStep',
  auth: 'app',
  fingerprint: 'wgj03fpBv8Zngmx2XpfzIYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markChangesResolvedRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'markChangesResolved',
  auth: 'app',
  fingerprint: 'PSHl0Mk40-nOe69Itno0uoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestAgentToApplyChangesRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestAgentToApplyChanges',
  auth: 'app',
  fingerprint: 'SZamX2qNXua9kx2Jj3hbCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestAgentToReviewRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestAgentToReview',
  auth: 'app',
  fingerprint: 'gupRi2mXeYpoV53V6gXhSoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelAgentTurnRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'cancelAgentTurn',
  auth: 'app',
  fingerprint: 'HKdvkEMvTjJEYRYcVjocnYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'cancelApproval',
  auth: 'app',
  fingerprint: 'HrDzSXNmqRt0oxSn2tS9MYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const concludeApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'concludeApproval',
  auth: 'app',
  fingerprint: 'tO-XK7M_hRVIRwLD1j28LIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'updateApproval',
  auth: 'app',
  fingerprint: 'gDeQITkILFMFlingaYzDQoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendReminderNotificationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'sendReminderNotification',
  auth: 'app',
  fingerprint: 'CLm0NFVWppmLVdc5zf35iYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};